"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match");

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// import moment from 'moment'
// import Pagination from '@/components/Pagination' // secondary package based on el-pagination
// import QRCode from "qrcodejs2";
var _default = {
  name: 'account:updatePayPassword',
  extends: _PermissionPage.default,
  components: {
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      list: null,
      passwordTemp: {
        oldPayPassword: '',
        newPayPassword: '',
        confirmPayPassword: ''
      },
      costTemp: [],
      key: 1,
      qrcodeTemp: {
        googleQrcode: null,
        agentAccount: null
      }
    };
  },
  created: function created() {},
  computed: {
    errorInfo: function errorInfo() {
      return {
        emptyOldPayPassword: this.$t('SMS.oldPayPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyNewPayPassword: this.$t('SMS.newPayPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyConfirmPayPassword: this.$t('SMS.confirmPayPassword') + this.$t('SMS.canNotBeEmpty'),
        invalidPasswordLength: this.$t('message.organizationManagementMessage13'),
        invalidPasswordFormat: this.$t('warningMessage.passwordFormatNoUpperMessage'),
        organizationManagementMessage14: this.$t("message.organizationManagementMessage14")
      };
    },
    rules: function rules() {
      var _this = this;

      var checkPasswordFormat = function checkPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (!value) {
          return callback(new Error(_this.errorInfo.emptyNewPayPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this.errorInfo.invalidPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      var checkPassword = function checkPassword(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this.errorInfo.emptyConfirmPayPassword));
        }

        if (_this.passwordTemp.newPayPassword !== value) {
          return callback(new Error(_this.errorInfo.organizationManagementMessage14));
        }

        return callback();
      };

      var checkOldPayPassword = function checkOldPayPassword(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this.errorInfo.emptyOldPayPassword));
        }

        return callback();
      };

      return {
        oldPayPassword: [{
          required: true,
          validator: checkOldPayPassword,
          trigger: 'blur'
        }],
        newPayPassword: [{
          required: true,
          validator: checkPasswordFormat,
          trigger: 'blur'
        }],
        confirmPayPassword: [{
          required: true,
          validator: checkPassword,
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    doResetTemp: function doResetTemp() {
      this.passwordTemp = {
        oldPayPassword: '',
        newPayPassword: '',
        confirmPayPassword: ''
      };
    },
    doUpdatePassword: function doUpdatePassword() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var controller = '';

          if (_this2.$store.getters.isAgent) {
            controller = 'agentUser';
          }

          if (_this2.$store.getters.isMerchant) {
            controller = 'organizationUser';
          }

          _httpUtils.default.post(controller, "payPassword/update", null, _this2.passwordTemp).then(function (res) {
            if (res.code === 200) {
              _this2.$notify({
                title: _lang.default.t('message.message71'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this2.doResetTemp();
              }, 1 * 1000);
            }

            if (res.code === 500) {
              _this2.$notify({
                title: _lang.default.t('message.message42'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (error) {
            _this2.$message({
              message: error.message,
              type: 'error'
            });
          });
        }
      });
    }
  }
};
exports.default = _default;